import moment from "moment";
import React from "react";
import { useState, useEffect } from "react";
import { isOutside } from "../utils/click-outside";

//return header for weekday name
const WeekdayHeader = () => {
  const weekdayShortName = moment.weekdaysShort();
  return (
    <div className="weekday-wrapper">
      {weekdayShortName.map((day) => {
        return (
          <span key={"weekday-item" + day} className="weekday-item">
            {day}
          </span>
        );
      })}
      <style jsx>{`
        .weekday-wrapper {
          display: flex;
          background-color: darkslategray;
        }
        .weekday-item {
          color: white;
          font-weight: 500;
          width: 36px;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

//return row with three column content each
const threeColumnRowCreator = (elementList) => {
  let rows = [];
  let cells = [];

  elementList.forEach((element, i) => {
    if (i % 3 !== 0 || i == 0) {
      cells.push(element);
    } else {
      rows.push(cells);
      cells = [];
      cells.push(element);
    }
  });

  rows.push(cells);

  return rows;
};

const CalendarDay = ({ dateObject, selectedDate, dateSetter }) => {
  const firstDayOfMonth = Number(
    moment(dateObject).startOf("month").format("d")
  );

  let emptyDayInMonthElement = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    emptyDayInMonthElement.push(
      <span
        className="calendar-day calendar-day--empty"
        key={"calendar-day--empty" + i}
      >
        {""}
      </span>
    );
  }

  let dayInMonthElement = [];
  let today =
    Number(moment().format("D")) > moment(dateObject).daysInMonth()
      ? moment(dateObject).daysInMonth()
      : moment().format("D");

  for (let i = 1; i <= moment(dateObject).daysInMonth(); i++) {
    dayInMonthElement.push(
      <span
        key={"calendar-day" + i}
        onClick={() => {
          dateSetter(i);
        }}
        className={`calendar-day ${i == today ? "calendar-day--today" : ""} ${
          i == selectedDate ? "calendar-day--selected" : ""
        }`}
      >
        {i}
      </span>
    );
  }

  let total = [...emptyDayInMonthElement, ...dayInMonthElement];
  let rows = [];
  let cells = [];

  total.forEach((row, i) => {
    if (i % 7 !== 0) {
      cells.push(row); // if index not equal 7 that means not go to next week
    } else {
      rows.push(cells); // when reach next week we contain all td in last week to rows
      cells = []; // empty container
      cells.push(row); // in current loop we still push current row to new container
    }
    if (i === total.length - 1) {
      // when end loop we add remain date
      rows.push(cells);
    }
  });

  let totalDaysInMonth = rows.map((d, i) => {
    return (
      <div className="calendar-day-row" key={"calendar-day-row" + i}>
        {d}
        <style jsx global>{`
          .calendar-day-row {
            display: flex;
            justify-content: flex-start;
          }
          .calendar-day {
            width: 36px;
            text-align: center;
            cursor: pointer;
          }
          .calendar-day:hover {
            background-color: darkslategray;
            color: white;
          }
          .calendar-day--today {
            border: 1px solid rgb(15, 147, 223);
            color: rgb(15, 147, 223);
            border-radius: 50%;
          }
          .calendar-day--empty {
            background-color: lightgray;
            cursor: default;
          }
          .calendar-day--selected {
            background-color: darkslategray;
            color: white;
          }
          .calendar-day--empty:hover {
            background-color: lightgray;
          }
        `}</style>
      </div>
    );
  });

  return (
    <div className="calendar-day-wrapper">
      {" "}
      {totalDaysInMonth}
      <style jsx>{`
        .calendar-day-wrapper {
          background-color: white;
        }
      `}</style>
    </div>
  );
};

const CalendarMonth = ({
  selectedMonth,
  monthSetter,
  monthPickerToogler,
  showMonthPicker
}) => {
  const monthNameList = moment.months();

  let monthElement = [];

  for (let i = 0; i < monthNameList.length; i++) {
    monthElement.push(
      <span
        className="calendar-month"
        key={"calendar-month" + i}
        onClick={() => monthSetter(i + 1)}
      >
        {" "}
        {monthNameList[i]}
      </span>
    );
  }

  const monthlist = threeColumnRowCreator(monthElement).map((m, i) => {
    return (
      <div className="calendar-month-row" key={"calendar-month-row" + i}>
        {m}
        <style jsx global>{`
          .calendar-month-row {
            display: flex;
          }
          .calendar-month {
            flex: 1;
            cursor: pointer;
            padding: 3px 5px;
          }
          .calendar-month:hover {
            background-color: darkslategray;
            color: white;
          }
        `}</style>
      </div>
    );
  });

  return (
    <div
      className={
        "calendar-month-wrapper" +
        (!showMonthPicker ? " calendar-month-wrapper--flex" : "")
      }
    >
      <div
        className="calendar-month-selected"
        onClick={() => {
          monthPickerToogler(!showMonthPicker);
        }}
      >
        {monthNameList[selectedMonth]}
      </div>
      <div
        className={
          "calendar-month-row-wrapper" +
          (!showMonthPicker ? " calendar-month-row-wrapper--hide" : "")
        }
      >
        {" "}
        {monthlist}{" "}
      </div>
      <style jsx>{`
        .calendar-month-wrapper--flex {
          display: flex;
        }
        .calendar-month-selected {
          background-color: darkslategray;
          text-align: center;
          color: white;
          cursor: pointer;
          flex: 3;
        }
        .calendar-year-trigger {
          flex: 1;
          background-color: darkslategray;
          text-align: center;
          color: white;
          cursor: pointer;
        }
        .calendar-year-trigger:hover,
        .calendar-month-selected:hover {
          background-color: rgb(39, 66, 66);
        }
        .calendar-month-row-wrapper {
          background-color: white;
        }
        .calendar-month-row-wrapper--hide {
          display: none;
        }
      `}</style>
    </div>
  );
};

const CalendarYear = ({
  selectedYear,
  yearSetter,
  showYearPicker,
  yearPickerToogler
}) => {
  const [startYear, setStartYear] = useState(
    moment().set("year", selectedYear).format("Y")
  );
  const [endYear, setEndYear] = useState(
    moment().set("year", selectedYear).add(12, "year").format("Y")
  );

  const setYearRange = (range) => {
    setStartYear(
      moment().set("year", Number(startYear)).add(range, "year").format("Y")
    );
    setEndYear(
      moment().set("year", Number(endYear)).add(range, "year").format("Y")
    );
  };

  const getYearList = (startYear, endYear) => {
    let tempYearList = [];
    for (let i = startYear; i < endYear; i++) {
      tempYearList.push(i);
    }
    return tempYearList;
  };

  const yearListRaw = getYearList(startYear, endYear);

  let yearElement = [];

  for (let i = 0; i < yearListRaw.length; i++) {
    yearElement.push(
      <span
        key={"calendar-year" + i}
        className="calendar-year"
        onClick={() => {
          yearSetter(yearListRaw[i]);
        }}
      >
        {yearListRaw[i]}
      </span>
    );
  }

  const yearList = threeColumnRowCreator(yearElement).map((y, i) => {
    return (
      <div className="calendar-year-row" key={"calendar-year-row" + i}>
        {y}
        <style jsx global>{`
          .calendar-year-row {
            display: flex;
          }
          .calendar-year {
            flex: 1;
            cursor: pointer;
            padding: 3px 5px;
          }
          .calendar-year:hover {
            background-color: darkslategray;
            color: white;
          }
        `}</style>
      </div>
    );
  });

  return (
    <div className="calendar-year-wrapper">
      <div className="calendar-year-header">
        {showYearPicker && (
          <div
            className="calendar-year-nav"
            onClick={() => {
              setYearRange(-12);
            }}
          >
            {" "}
            {"<"}{" "}
          </div>
        )}
        <div
          className="calendar-year-selected"
          onClick={() => {
            yearPickerToogler(!showYearPicker);
          }}
        >
          {selectedYear}
        </div>
        {showYearPicker && (
          <div
            className="calendar-year-nav"
            onClick={() => {
              setYearRange(12);
            }}
          >
            {" "}
            {">"}{" "}
          </div>
        )}
      </div>
      <div
        className={
          "calendar-year-row-wrapper" +
          (!showYearPicker ? " calendar-year-row-wrapper--hide" : "")
        }
      >
        {yearList}
      </div>
      <style jsx>{`
        .calendar-year-nav {
          cursor: pointer;
          font-weight: 500;
          font-size: 18px;
          flex: 1;
        }
        .calendar-year-nav:hover {
          background-color: rgb(39, 66, 66);
        }
        .calendar-year-header {
          display: flex;
          justify-content: space-around;
          background-color: darkslategray;
          color: white;
          align-items: center;
          cursor: pointer;
        }
        .calendar-year-wrapper {
          text-align: center;
          background-color: white;
        }
        .calendar-year-row-wrapper--hide {
          display: none;
        }
        .calendar-year-selected {
          flex: 2;
        }
        .calendar-year-selected:hover {
          background-color: rgb(39, 66, 66);
        }
      `}</style>
    </div>
  );
};

const Datepicker = ({
  className,
  onChange,
  value,
  hasError,
  dateFormat,
  disabled,
  id,
  placeholder,
  minimumYear = 0
}) => {
  let defaulDate = value
    ? moment(value, dateFormat)
    : moment().subtract(minimumYear, "years");
  const [dateObject, setDateObject] = useState(defaulDate);
  const [month, setMonth] = useState(defaulDate.format("M"));
  const [year, setYear] = useState(defaulDate.format("Y"));
  const [date, setDate] = useState(defaulDate.format("D"));
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [showYearPicker, setShowYearPicker] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [pickerShowed, setPickerShowed] = useState(false); //to Emit Only When picker showed at least once

  useEffect(() => {
    let tempDateObject = Object.assign({}, dateObject);
    setDateObject(moment(tempDateObject).set("month", Number(month) - 1));
    setShowMonthPicker(false);
  }, [month]);

  useEffect(() => {
    let tempDateObject = Object.assign({}, dateObject);
    setDateObject(moment(tempDateObject).set("year", Number(year)));
    setShowYearPicker(false);
  }, [year]);

  useEffect(() => {
    let tempDateObject = Object.assign({}, dateObject);
    setDateObject(moment(tempDateObject).set("date", Number(date)));
  }, [date]);

  useEffect(() => {
    if (pickerShowed) {
      onChange(
        moment(dateObject).format(dateFormat ? dateFormat : "YYYY-MM-DD")
      );
    }
  }, [dateObject]);

  useEffect(() => {
    value &&
      onChange(
        moment(dateObject).format(dateFormat ? dateFormat : "YYYY-MM-DD")
      );
  }, [value]);

  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (
        isOutside(document.getElementById("datePickerComponent" + id), e.target)
      ) {
        setShowDatePicker(false);
      }
    });
  });

  const showYearPickerWrapper = (val) => {
    setShowYearPicker(val);

    if (val) {
      setShowMonthPicker(true);
    }
  };

  const setDateWrapper = (val) => {
    setDate(val);
    if (val) {
      setShowDatePicker(false);
    }
  };

  const showPicker = () => {
    setPickerShowed(true);
    disabled ? setShowDatePicker(false) : setShowDatePicker(true);
  };

  const onYearClicked = (yearParams) => {
    if (year == yearParams) {
      //to trigger dateObject update even pick the same year as current active year
      let tempDateObject = Object.assign({}, dateObject);
      setDateObject(moment(tempDateObject).set("year", yearParams));
      setShowYearPicker(false);
      return;
    }
    setYear(yearParams);
  };

  const onMonthClicked = (monthParams) => {
    if (month == monthParams) {
      //to trigger dateObject update even pick the same month as current active month
      let tempDateObject = Object.assign({}, dateObject);
      setDateObject(moment(tempDateObject).set("month", monthParams - 1));
      setShowMonthPicker(false);
      return;
    }
    setMonth(monthParams);
  };

  return (
    <React.Fragment>
      <div className="datepicker" id={"datePickerComponent" + id}>
        <div
          className={
            "datepicker--input" +
            (disabled ? " datepicker--input--disabled" : "")
          }
        >
          <input
            placeholder={placeholder}
            type="text"
            className={
              "input " +
              (className ? className : "") +
              (hasError ? "input--error" : "")
            }
            onClick={showPicker}
            value={value}
            readOnly
            disabled={disabled}
          />
        </div>
        <div
          className={
            "datepicker--calendar" +
            (!showDatePicker ? " datepicker--calendar--hide" : "")
          }
          id="datePickerCalendar"
        >
          {
            <CalendarYear
              selectedYear={year}
              yearSetter={onYearClicked}
              showYearPicker={showYearPicker}
              yearPickerToogler={showYearPickerWrapper}
            ></CalendarYear>
          }
          {!showYearPicker && (
            <CalendarMonth
              selectedMonth={Number(month) - 1}
              monthSetter={onMonthClicked}
              showMonthPicker={showMonthPicker}
              monthPickerToogler={setShowMonthPicker}
            ></CalendarMonth>
          )}
          {!showMonthPicker && !showYearPicker && (
            <div>
              <WeekdayHeader></WeekdayHeader>
              <CalendarDay
                selectedDate={date}
                dateSetter={setDateWrapper}
                dateObject={dateObject}
              ></CalendarDay>
            </div>
          )}
        </div>
        <style jsx>{`
          .input {
            border: 0;
            min-width: 0;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            color: #000;
            padding: 0.75rem 1.5rem;
            -webkit-appearance: unset;
            border: 1px solid #fff;
            font-size: 16px;
            box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
            border-radius: 8px;
            cursor: text;
          }
          .input--error {
            border: 1px solid var(--color-red);
          }
          .datepicker--calendar {
            position: absolute;
            z-index: 1;
            border: 1px solid darkslategray;
            border-radius: 1px;
            width: 260px;
            margin-top: 10px;
          }
          .datepicker--calendar--hide {
            display: none;
          }
          .datepicker--input {
            display: flex;
            position: relative;
          }
          .datepicker--input--disabled .input {
            cursor: not-allowed;
            background-color: lightgray;
            color: gray;
          }
        `}</style>
      </div>
    </React.Fragment>
  );
};

export default Datepicker;
